module.exports = __webpack_public_path__ + "imgs/leaf-header-background.055c97fadb16cfa1763da9e4ea5230bd.svg";